import { contactEntity } from "../../model/entity/contact-entity";
import { Enums } from "../../helper/enums";
import _, { map } from "lodash";
import { technicianEntity } from "../../../common/model/entity/technician-entity";
import { ErrorTemplateBuilder } from "../../../infrastructure/error-template-builder";
import PrototypeInstance from "../../helper/prototype-instance";

export class SignalRPostActions {
  private static filterAccessibleContacts(entityResponse: any) {
    return _.filter(entityResponse, function (contact: any) {
      return contact.isAccessible == true;
    });
  }

  static PostCallBackForEntity(
    caseFilter: Enums.SignalRMessageType,
    entityResponse: any = null,
  ) {
    switch (caseFilter) {
      case Enums.SignalRMessageType.ContactEntitySync:
        if (entityResponse != null) {
          let accessibleContacts =
            SignalRPostActions.filterAccessibleContacts(entityResponse);
          contactEntity.insertOrUpdate({
            data: accessibleContacts,
          });
        }
        break;
      case Enums.SignalRMessageType.ContactEntityTickSync:
        if (entityResponse != null) {
          contactEntity.insertOrUpdate({ data: entityResponse }).then(() => {
            this.deleteContactsOfClientsNotInSystem();
          });
        }
        break;
      case Enums.SignalRMessageType.ContactInactiveEntitySync:
        let accessibleContacts =
          SignalRPostActions.filterAccessibleContacts(entityResponse);

        contactEntity.insertOrUpdate({
          data: accessibleContacts,
        });
        break;
    }
  }

  static async deleteContactsOfClientsNotInSystem() {
    let technician = technicianEntity
      .query()
      .where(
        "technicianId",
        PrototypeInstance.globalProperties.$LoggedInUser.technicianId,
      )
      .first();

    if (technician && !technician.isSignupUser) {
      let technicianGroupIds: any[] = [];
      if (technician.subscribedGroupIds) {
        technicianGroupIds = technician.subscribedGroupIds;
      }
      let contactsWithClientNotPresentInSystem = contactEntity
        .query()
        .where((contact: any) => {
          if (contact.isAccessible == false) {
            return true;
          }
          //if (contact.clientId != null && contact.clientId > 0) {
          //    let clientSubscribedGroups = clientSubscribedGroupEntity.query<any>().where('clientId', contact.clientId).all();
          //    let clientGroupIds = map(clientSubscribedGroups, 'technicianGroupId');

          //    //Checking if logged in technician has any groups matching the assigned client's groups
          //    for (let i = 0; i < clientGroupIds.length; i++) {
          //        //If group is matched
          //        if (technicianGroupIds.includes(clientGroupIds[i])) {
          //            return false;
          //        }
          //    }

          //    //If group was not found, contact needs to be deleted
          //    return true;

          //}
          return false;
        })
        .all();

      if (contactsWithClientNotPresentInSystem.length > 0) {
        let contactIdsToDelete = map(
          contactsWithClientNotPresentInSystem,
          "contactId",
        );

        try {
          await contactEntity.delete((contact: any) => {
            return contactIdsToDelete.includes(contact.contactId);
          });
        } catch (e) {
          console.error(
            ErrorTemplateBuilder.getCatchText(
              "EntitySyncManager.deleteContactsOfClientsNotInSystem",
              e,
            ),
          );
        }
      }
    }
    //}
  }
}
